import {
  BadgeCheck,
  Banknote,
  Boxes,
  Building2,
  CalendarCheck2,
  ClipboardList,
  Coins,
  DollarSign,
  Factory,
  FileBarChart2,
  FileText,
  HardDrive,
  HeartPulse,
  Home,
  Landmark,
  type LucideIcon,
  Megaphone,
  PieChart,
  Receipt,
  Ruler,
  Stethoscope,
  Tag,
  Tags,
  Trophy,
  Truck,
  UserCog,
  Users,
  Users2,
  Warehouse,
} from 'lucide-react';

export interface NavItem {
  readonly label: string;
  readonly to: string;
  readonly icon: LucideIcon;
  readonly badge?: string;
  readonly disabled?: boolean;
}

export interface NavSection {
  readonly label: string;
  readonly items: readonly NavItem[];
}

export const NAVIGATION: readonly NavSection[] = [
  {
    label: 'General',
    items: [{ label: 'Dashboard', to: '/', icon: Home }],
  },
  {
    label: 'Operación',
    items: [
      { label: 'Afiliados', to: '/admin/afiliados', icon: Users },
      { label: 'Contratos', to: '/contratos', icon: FileText },
      { label: 'Citas médicas', to: '/citas', icon: CalendarCheck2 },
      { label: 'Cuotas', to: '/cuotas', icon: Coins },
      { label: 'Facturación', to: '/facturas', icon: Receipt },
      { label: 'Recaudos', to: '/recaudos', icon: PieChart },
    ],
  },
  {
    label: 'Documentos numerados',
    items: [
      { label: 'Recibos', to: '/recibos', icon: ClipboardList },
      { label: 'Provisionales', to: '/provisionales', icon: ClipboardList },
      { label: 'Tarjetas de cobro', to: '/tarjetas-cobro', icon: Banknote },
      { label: 'Papelería', to: '/papeleria', icon: FileText },
      { label: 'Descuentos', to: '/descuentos', icon: Tags },
      { label: 'Planillas', to: '/planillas', icon: ClipboardList },
      { label: 'Cheques', to: '/cheques', icon: Banknote },
      { label: 'Publicidad', to: '/publicidad', icon: Megaphone },
    ],
  },
  {
    label: 'Incentivos',
    items: [
      { label: 'Bonificaciones', to: '/bonificaciones', icon: Trophy },
    ],
  },
  {
    label: 'Inventario',
    items: [
      { label: 'Inventario', to: '/inventario', icon: Boxes },
      { label: 'Tipos de ítem', to: '/inventario/tipos', icon: Tag },
      { label: 'Bodega', to: '/bodega', icon: Warehouse },
      { label: 'Compras', to: '/compras', icon: Truck },
      { label: 'Activos fijos', to: '/activos', icon: HardDrive },
    ],
  },
  {
    label: 'Reportes',
    items: [
      { label: 'Centro de reportes', to: '/reportes', icon: FileBarChart2 },
      { label: 'SIIGO', to: '/siigo', icon: ClipboardList },
    ],
  },
  {
    label: 'Administración',
    items: [
      { label: 'Usuarios', to: '/admin/usuarios', icon: UserCog },
      { label: 'Sucursales', to: '/admin/sucursales', icon: Building2 },
      { label: 'Municipios', to: '/admin/municipios', icon: Landmark },
      { label: 'Especialidades', to: '/admin/especialidades', icon: HeartPulse },
      { label: 'Equipos', to: '/admin/equipos', icon: Users2 },
      { label: 'Estándares', to: '/admin/estandares', icon: Ruler },
      { label: 'Tipos de agente', to: '/admin/tipos-agente', icon: Tags },
      { label: 'Doctores', to: '/admin/doctores', icon: Stethoscope },
      { label: 'Agentes', to: '/admin/agentes', icon: BadgeCheck },
      { label: 'Proveedores', to: '/admin/proveedores', icon: Factory },
      { label: 'Tarifas', to: '/admin/tarifas', icon: DollarSign },
    ],
  },
];
